import logo from "./logo.svg";
import "./App.css";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { checkAuthLoader, getAuthToken } from "./utils/auth";
import RootLayout from "./pages/root";
import AuthPage from "./pages/Auth";
import Dashboard from "./pages/Dashboard";
import PalmData from "./pages/palm_data";
import { QueryClientProvider, QueryClient } from "@tanstack/react-query";
import { ToastContainer } from "react-toastify";

const router = createBrowserRouter([
  {
    path: "/",
    loader: getAuthToken,
    id: "root",
    element: <RootLayout />,
    children: [
      {
        index: true,
        element: <Dashboard />,
        loader: checkAuthLoader,
      },
      {
        path: "palm",
        element: <PalmData />,
        loader: checkAuthLoader,
      },
    ],
  },
  {
    path: "auth",
    element: <AuthPage />,
  },
]);
const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      <ToastContainer />
    </QueryClientProvider>
  );
}

export default App;
